import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/surface';

export function NotFound() {
  return (
    <div className="grid min-h-[70dvh] place-items-center px-4">
      <Card className="flex max-w-md flex-col items-center gap-4 p-8 text-center">
        <img src="/draper/state-idle-still.webp" alt="" className="size-20" />
        <div>
          <h1 className="text-[18px] font-semibold text-ink">Nothing here</h1>
          <p className="mt-1.5 text-[14px] text-ink-3">That page doesn't exist, or it moved.</p>
        </div>
        <Button variant="primary" asChild>
          <Link to="/">Go home</Link>
        </Button>
      </Card>
    </div>
  );
}
